export default function (state) {
    if(state.auth){
        return state.loading||state.permit.loading||state.setting.loading;
    }else{
        return state.loading;
    }
}